import React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  SvgIcon,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import Location from '../Location/Location';
import { styles } from './allStyles';
import MarketingLabel from '../EventCard/MarketingLabel';
import EventTypeLabel from './EventTypeLabel';

const EVENT_LOCATIONS = {
  MSK: 'Москва',
  SPB: 'Санкт−Петербург',
  ONLINE: 'Онлайн',
};

export default function EventsMobileBlockCard(props) {
  const {
    title,
    location,
    format: eventFormat,
    shortDescription,
    isLoading,
    date,
    startTime,
    url_slug,
    external_url,
    clickHandler,
    startGrid,
    image,
    marketingLabel,
    subTitleEnum,
    cardBullits,
    program,
  } = props;
  const isMobile = useMediaQuery((t) => t.breakpoints.down('sm'));

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        maxWidth: 412,
        height: 388,
        borderRadius: 6,
        p: (t) => t.spacing(2, 2, 2.5, 3),
        position: 'relative',
        background: styles.backgroundGenerate(program),
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <EventTypeLabel type={subTitleEnum} />
      {marketingLabel && (
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            right: 10,
          }}
        >
          <MarketingLabel label={marketingLabel} />
        </Box>
      )}
      <Grid
        container
        columnGap={4}
        sx={{ width: '100%', mt: 6, maxHeight: 172, minHeight: 172 }}
      >
        <Grid
          item
          xs={3.65}
          sx={{
            position: 'relative',
            '&::after': {
              content: '""',
              display: 'flex',
              position: 'absolute',
              height: '100%',
              width: '2px',
              backgroundColor: 'kit.text.h',
              right: '-14px',
              top: '50%',
              transform: 'translate(50%, -50%)',
            },
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              color: 'kit.infographic.darkPurple',
            }}
          >
            <Box
              sx={{
                maxWidth: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography variant="desktopH4" sx={{ fontSize: 34 }}>
                {date && date[1]}
              </Typography>
              <Typography variant="desktopH4" sx={{ fontSize: 18 }}>
                {date && date[2]}
              </Typography>
              <Typography variant="desktopP3Helper" mt={1}>
                {date && date[0]}
              </Typography>
              <Typography
                variant="desktopP2"
                sx={{
                  mt: 1.75,
                  fontFamily: 'RF Rostin',
                  letterSpacing: -1,
                  fontSize: 18,
                }}
              >
                {startTime}
              </Typography>
              <Typography variant="desktopP3Helper" mt={0.5}>
                по Мск
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={7}>
          <Typography
            variant="desktopH4"
            sx={{
              maxWidth: 600,
              fontWeight: 700,
              fontSize: 20,
              color: 'kit.text.main',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box !important',
              WebkitLineClamp: '3',
              lineClamp: '3',
              maxLines: '3',
              WebkitBoxOrient: 'vertical',
            }}
          >
            {title}
          </Typography>
          <Box sx={{ mt: 3 }}>
            {cardBullits?.map((item) => (
              <Box
                key={item}
                sx={{
                  display: 'flex',
                  gap: 1,
                  '&:not(:first-of-type)': { mt: 1 },
                }}
              >
                <SvgIcon
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  sx={{ width: 16, height: 16 }}
                >
                  <rect width="20px" height="20px" rx="4" fill="#4520AB" />
                  <path
                    d="M6 9.93941L8.70833 12.6667L14.6667 6.66669"
                    stroke="#F8F6FC"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </SvgIcon>
                <Typography
                  variant="desktopP3Helper"
                  sx={{ color: 'kit.text.secondary', fontSize: 12 }}
                  fontSize={12}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </Box>
          {/* <Typography
            variant="desktopP3"
            sx={{
              fontSize: 14,
              mt: 1.5,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box !important',
              WebkitLineClamp: '5',
              lineClamp: '5',
              maxLines: '5',
              WebkitBoxOrient: 'vertical',
            }}
          >
            {shortDescription}
          </Typography> */}
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mt: 'auto',
          // alignItems: 'center',
        }}
      >
        <Box fontSize={12} sx={{ fontSize: 14 }}>
          <Location location={location} />
        </Box>
        <Link
          href={external_url || `/events/${url_slug}/`}
          target={external_url ? '_blank' : '_self'}
          sx={styles.link}
        >
          <Button
            variant="kitPrimary"
            size="medium"
            disabled={isLoading}
            sx={{ marginRight: '10px' }}
          >
            Подробнее
          </Button>
        </Link>
      </Box>
    </Paper>
  );
}
